import {priority} from '@priority-software/priority-proto-api/lib';
import {action, makeObservable, observable} from 'mobx';
import {FamilyResults, PartsDetails} from './types';

class PartsStore {
    @observable selectedItems: Map<string, PartsDetails> = new Map();
    @observable session: string;
    @observable countSession: string;
    @observable partsDetails: PartsDetails[] = [];
    @observable selectedColumns: string[] = [];
    @observable selectedFamilies: string[];

    @observable page: number = 1;
    @observable pagesCount: number = 0;
    @observable showQuantitySelector: boolean = true;
    editingColumns: priority.netitems.form.IColumn[];
    families: FamilyResults[];
    currentFormName: string;
    @observable searchParams = {
        page: 0,
        query: '',
        selectedFamilies: [],
        selectedColumns: []
    };

    constructor() {
        makeObservable(this);
    }
    setSession = session => {
        this.session = session;
    };
    @action
    setSetSearchParams = newSearchParams => {
        this.searchParams = {...this.searchParams, ...newSearchParams};
    };

    setEditingColumns = (columns: priority.netitems.form.IColumn[]) => {
        this.editingColumns = columns;
    };

    setSelectedColumns = (columns: string[]) => {
        this.selectedColumns = columns;
    };

    setQuantitySelector = (shouldShowSelector: boolean) => {
        this.showQuantitySelector = shouldShowSelector;
    };
    @action
    setPartsDetails = (partsDetails: PartsDetails[]) => {
        this.partsDetails = partsDetails;
    };

    toggleSelectedItems = (partItem: PartsDetails) => {
        if (this.selectedItems.has(partItem.partName)) {
            this.selectedItems.delete(partItem.partName);
        } else {
            this.selectedItems.set(partItem.partName, partItem);
        }
    };

    clearSelectedItem = () => {
        this.selectedItems = new Map();
    };

    setSelectedFamilies = (selectedFamilies: string[]) => {
        this.selectedFamilies = selectedFamilies;
    };

    setFamilies = (families: FamilyResults[]) => {
        this.families = families;
    };

    @action
    setPage = nextPage => {
        this.page = nextPage;
    };

    setPagesCount = (pagesCount: number) => {
        this.pagesCount = pagesCount;
    };
    clearData = () => {
        this.setPartsDetails([]);
        this.setSession([]);
        this.setSelectedFamilies([]);
        this.setFamilies([]);
        this.clearSelectedItem();
        this.setPage(1);
    };
}

export const partsStore = new PartsStore();
